import React from 'react'
import PropTypes from 'prop-types'
import { Typography, Tooltip } from '@mui/material'
import styled from 'styled-components'

const ClampedTypography = styled(Typography)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  line-height: 1.2em;
  max-height: calc(1.2em * 2);
  cursor: default;
`

const ProductNameContainer = ({ productName, width, maxWidth }) => {
  return (
    <Tooltip title={productName} placement="top" arrow>
      <ClampedTypography
        component="div"
        style={{
          fontWeight: 'bold',
          fontSize: '16px',
          width: width,
          maxWidth: maxWidth,
        }}
      >
        {productName}
      </ClampedTypography>
    </Tooltip>
  )
}

ProductNameContainer.propTypes = {
  productName: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

ProductNameContainer.defaultProps = {
  width: '100%',
  maxWidth: '100%',
}

export default ProductNameContainer
